import { RECOMMENDED_ITEMS_API_BASE, CODE_PARAM, RECOMMENDED_ITEMS_API_KEY } from '../Constants/APIConstants';

const getRecommendedItems = (location, itemId) => {
    let url = new URL(`${RECOMMENDED_ITEMS_API_BASE}${location}/${itemId}`);
    url.searchParams.append(CODE_PARAM, RECOMMENDED_ITEMS_API_KEY);

    return fetch(url, {});
}

export default getRecommendedItems;